import React, { ReactNode } from 'react';
import cx from 'classnames';

export interface SubtitleProps {
  className?: string;
  label?: ReactNode;
}

export function Subtitle({ label, className }: SubtitleProps) {
  return (
    <span
      className={cx(className, 'text-[21px] font-bold v2-text-neutral-900')}
    >
      {label}
    </span>
  );
}
